export default __webpack_public_path__ + "static/media/wf-isf-expanded-goals-hero-desktop-v2.543b9e1f.jpg";